module.exports = __webpack_public_path__ + "img/article-arrow-20x20.aeb79dfa.svg";